export { ToggleTabs } from './ToggleTabs'
export type { ToggleTabOption, ToggleTabsProps } from './ToggleTabs'
